// api
import type {
  CreateExternalSensorDto,
  EditExternalSensorDto,
  ExternalSensorsGetAsyncByidApiResponse,
  ExternalSensorsGetCollectionAsyncByqueryOptionsApiResponse,
  ReadManufacturerDto,
} from '@/api/generated/recalc/endpoints/v1/externalSensors';

// relative
import { apiSlice } from '../../apiSlice';

export const externalSensorsApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['ExternalSensors', 'ExternalSensorManufacturers'],
  endpoints: (builder) => ({
    getExternalSensorsByAccountId: builder.query<
      ExternalSensorsGetCollectionAsyncByqueryOptionsApiResponse,
      number | undefined
    >({
      query: (accountId) => ({
        url: '/ExternalSensors',
        params: {
          orderby: 'ExternalSensorId',
          'Account.AccountId': `eq(${accountId})`,
          top: 10000,
        },
      }),
      providesTags: ['ExternalSensors'],
    }),
    getExternalSensorById: builder.query<
      ExternalSensorsGetAsyncByidApiResponse,
      number
    >({
      query: (id) => ({
        url: `/ExternalSensors/${id}`,
      }),
      providesTags: ['ExternalSensors'],
    }),
    getExternalSensorManufacturers: builder.query<ReadManufacturerDto[], void>({
      query: () => ({
        url: '/ExternalSensorManufacturers',
        params: {
          orderby: 'Name',
          top: 10000,
        },
      }),
      providesTags: ['ExternalSensorManufacturers'],
    }),
    postExternalSensor: builder.mutation<object, CreateExternalSensorDto>({
      query: (externalSensor) => ({
        url: '/ExternalSensors',
        method: 'POST',
        body: externalSensor,
      }),
      invalidatesTags: ['ExternalSensors'],
    }),
    patchExternalSensor: builder.mutation<
      object,
      { id: number; patch: EditExternalSensorDto }
    >({
      query: ({ id, patch }) => ({
        url: `/ExternalSensors/${id}`,
        method: 'PATCH',
        body: patch,
      }),
      invalidatesTags: ['ExternalSensors'],
    }),
    deleteExternalSensor: builder.mutation<object, number>({
      query: (id) => ({
        url: `/ExternalSensors/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ExternalSensors'],
    }),
  }),
});

export const {
  useGetExternalSensorsByAccountIdQuery,
  useLazyGetExternalSensorsByAccountIdQuery,
  useGetExternalSensorByIdQuery,
  useGetExternalSensorManufacturersQuery,
  usePostExternalSensorMutation,
  usePatchExternalSensorMutation,
  useDeleteExternalSensorMutation,
} = externalSensorsApiSlice;
